var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35629",
    "data-name": "Group 35629",
    transform: "translate(-12825 22484.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    transform: "translate(12825 -22484.441)",
    fill: "none",
    stroke: "#00cb5e",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86,
    r: 86,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86,
    r: 85,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_58524",
    "data-name": "Path 58524",
    d: "M-6078.476-20648.23a5.992,5.992,0,0,1-3.605-1.217l-20.83-15.937a5.935,5.935,0,0,1-1.106-8.322,5.937,5.937,0,0,1,8.319-1.109l15.528,11.883,27.458-46.223a5.933,5.933,0,0,1,5.108-2.9,5.891,5.891,0,0,1,3.024.836,5.93,5.93,0,0,1,2.072,8.133l-30.866,51.957a5.958,5.958,0,0,1-3.977,2.791A5.915,5.915,0,0,1-6078.476-20648.23Z",
    transform: "translate(18984.178 -1718.181)",
    fill: "#00cb5e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/success-check.bee69674cc3d94707e997b9baf72daba.svg";
export { ForwardRef as ReactComponent };